import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { PropTypes } from 'prop-types'
import {
  COLOR_ERROR,
  COLOR_GRAY_LIGHT,
  COLOR_PRIMARY,
  COLOR_MUTED,
  COLOR_GRAY__800,
  COLOR_GRAY__300,
} from '../../lib/colors'
import { Inter } from '../../lib/fonts'
import UIInputError from './UIInputError'

const UISelect = ({
  data,
  selectLabel,
  kind,
  dynamicStyle,
  placeholder,
  message,
  errorMessage,
  ...props
}) => {
  const isInError = !!errorMessage
  const hasMessage = !!message && !isInError
  return (
    <div className={css(styles.container, dynamicStyle && dynamicStyle)}>
      {selectLabel && <p className={css(styles.label)}>{selectLabel}</p>}
      <select
        id="select"
        className={css(styles.basic, styles[kind])}
        {...props}
      >
        <option value="">{placeholder}</option>
        {data &&
          data.map((selectItem) => {
            return (
              <option key={selectItem.key} value={selectItem.value}>
                {selectItem.text}
              </option>
            )
          })}
      </select>
      {isInError && <UIInputError errorMessage={errorMessage} />}
      {hasMessage && <span className={css(styles.message)}>{message}</span>}
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
  },
  error: {
    color: COLOR_ERROR,
    borderColor: COLOR_ERROR,
  },
  success: {
    color: COLOR_PRIMARY,
    borderColor: COLOR_PRIMARY,
  },
  simple: {
    color: COLOR_GRAY__800,
    borderColor: COLOR_GRAY__300,
  },
  label: {
    color: COLOR_GRAY_LIGHT,
    fontFamily: 'Helvetica',
    fontSize: 14,
  },
  basic: {
    borderRadius: 6,
    width: '100%',
    fontSize: 15,
    fontFamily: [Inter, 'sans-serif'],
    padding: 10,
  },
  message: {
    fontWeight: 400,
    fontSize: 11,
    color: COLOR_MUTED,
  },
})

UISelect.propTypes = {
  data: PropTypes.array,
  selectLabel: PropTypes.string,
  kind: PropTypes.oneOf[('error', 'success', 'simple')],
  dynamicStyle: PropTypes.object,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  message: PropTypes.string,
}

export default UISelect
